// src/components/Home.js
import React, { useEffect } from "react";
import '../../styles/App.css';
import rocket from '../../assets/rocket_ic.svg';
import { FaArrowRight } from "react-icons/fa";

const Hero = () => {
  return <section id="home">
    <main className="background">
      <div>
        <div className="hero-container">
          <div className='space3'>
            {/* <h1 className='title-center'>The Construction Project </h1>
            <h1 className='title-center'>Management Platform to
              <span> Build
                <img src={rocket} alt="icon" className="icon" />
              </span>
            </h1>
            <h1 className='title-center'>Your Success</h1> */}
            <h1 className='title-center'> The Construction Project Management Platform to
              <span> Streamline
                <img src={rocket} alt="icon" className="" />
              </span>
              Your Projects
            </h1>
          </div>
          <div className='space2'>
            <h2 className='hero-subtitle-center'>
              ConRa helps streamline your projects from concept to completion through team collaboration and efficient task management
            </h2>
            {/* <h2 className='title-center'>
              With ConRa,  manage tasks efficiently.
            </h2> */}
          </div>
          <div className="space1">
            <div className="subscribe-container">
              <button className="filled-button"
                type='button'
                onClick={(e) => { }}>
                Learn More <FaArrowRight style={{ marginLeft: "6px" }} />
              </button>
              {/* <button className="outlined-button"
                type='button'
                onClick={(e) => { }}>
                See How It Works
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>;
};

export default Hero;
